/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Tooltip,
  Button,
  Grid,
  Drawer,
  TextField,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Slider
} from '@material-ui/core'
import PropTypes from 'prop-types'
import Card from 'components/Card/Card.js'
import CardHeader from 'components/Card/CardHeader.js'
import CardBody from 'components/Card/CardBody.js'
import CardIcon from 'components/Card/CardIcon.js'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChartSimple,
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faFilePdf,
  faFileExcel,
  faInfoCircle,
  faFilePen,
  faFileArrowUp
} from '@fortawesome/free-solid-svg-icons'
import AddCircle from '@material-ui/icons/AddCircle'
import Save from '@material-ui/icons/Save'
import CloseIcon from '@material-ui/icons/Close'
import { Edit } from '@material-ui/icons'
import Delete from '@material-ui/icons/Delete'
import insightsLogo from 'assets/img/insights_logo.PNG'
import { Fullscreen } from '@material-ui/icons'
import Tippy from '@tippyjs/react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import MultiSeriesLineChartvBAR from 'views/Orchestration/WhatsHappening/AuxComponents/MultiSeriesLineChartvBAR.js'
import { formatThresholds } from 'utils/thresholdUtils'
import { client } from '../../services/axiosClient'
import { ThreeDots } from 'react-loader-spinner'
import { formatNumber } from 'utils/formatNumberUtils.js'
import { Alert } from '@material-ui/lab'
import { getProgressColor } from 'utils/thresholdUtils'
import { CheckCircle, Cancel, HourglassEmpty } from '@material-ui/icons'
import {
  performResultsApprovalAction,
  approveAllResults
} from 'services/resultsApi'
import AuthContext from 'contexts/AuthProvider'
import { toast } from 'react-toastify'
import ChecklistRtlIcon from '@material-ui/icons/AssignmentTurnedIn'

import {
  lightenColor,
  darkenColor,
  pastelColorToRgb
} from '../../utils/colorUtils'
import { generateKpiReportPdf } from 'utils/pdfGenerator'

//component to render each KPI (chart/table) with functionality
const KPIChartCard = ({
  kpi,
  t,
  clientColor,
  classes,
  onReloadKpis,
  allowKpiEdits = true,
  canApprove,
  onApprovalAction,
  onApproveAll,
  isActionLoading,
  hasTargetBaseline = false
}) => {
  if (!kpi) return null
  const [timeAgg, setTimeAgg] = useState('monthly')
  const toggleTimeAgg = () =>
    setTimeAgg(prev => (prev === 'monthly' ? 'yearly' : 'monthly'))
  const [viewMode, setViewMode] = useState('chart')
  const toggleViewMode = () =>
    setViewMode(prev => (prev === 'chart' ? 'table' : 'chart'))
  const [openFullScreenDialog, setOpenFullScreenDialog] = useState(false)
  const handleOpenFullScreen = () => setOpenFullScreenDialog(true)
  const handleCloseFullScreen = () => setOpenFullScreenDialog(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const rawData = timeAgg === 'monthly' ? kpi.data.monthly : kpi.data.yearly
  const allLabels = rawData?.labels || []
  const [sliderRange, setSliderRange] = useState([0, allLabels.length - 1])
  const [isDrawerLoading, setIsDrawerLoading] = useState(false)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const marks = allLabels
    .map((lbl, idx) => ({
      value: idx,
      label: lbl // Rótulo do eixo X
    }))
    .filter((_, idx, arr) => {
      const total = arr.length - 1
      return (
        idx === 0 || // Primeiro elemento (0%)
        idx === total || // Último elemento (100%)
        idx === Math.round(total * 0.25) || // 25% da escala
        idx === Math.round(total * 0.5) || // 50% da escala
        idx === Math.round(total * 0.75) // 75% da escala
      )
    })

  useEffect(() => {
    // Sempre que as labels mudarem, redefinimos o sliderRange para cobrir tudo
    if (allLabels.length > 0) {
      setSliderRange([0, allLabels.length - 1])
    }
  }, [allLabels])
  //If there is a date filter, filter the data (assuming that the labels are in compatible format, eg "2025-01" or "2025")
  let filteredData = rawData
  let startIndex = sliderRange[0]
  let endIndex = sliderRange[1]
  if (endIndex < startIndex) {
    ;[startIndex, endIndex] = [endIndex, startIndex]
  }

  if (rawData && rawData.labels) {
    //STARTINDEX FILTRA TO ENDINDINDEX
    const filteredLabels = rawData.labels.slice(startIndex, endIndex + 1)
    const filteredSeries = rawData.series.map(serie =>
      serie.slice(startIndex, endIndex + 1)
    )

    filteredData = {
      ...rawData,
      labels: filteredLabels,
      series: filteredSeries
    }
  } else {
    filteredData = null
  }

  //========== Open Drawer ==============
  const handleOpenDrawer = mode => {
    setOpenDrawer(true)
    setIsDrawerLoading(true) // inicia spinner
    //Copy the same graphic aggregator
    setDrawerTimeAgg(timeAgg)
    //calls the function that carries the data from Real and Labels
    loadDataFromKPI(timeAgg)
    if (mode === 'edit') {
      //Loads the first line for editing (example)
      const dataObj = timeAgg === 'monthly' ? kpi.data.monthly : kpi.data.yearly
      if (dataObj && dataObj.labels && dataObj.series && dataObj.series[1]) {
        const index = 0
        setNewRow({
          period: dataObj.labels[index],
          real: dataObj.series[1][index] ?? ''
        })
      }
    } else {
      //to "add", allows the period editing
      setNewRow({ period: '', real: '' })
    }
  }
  const handleCloseDrawer = () => {
    setOpenDrawer(false)
  }
  const [kpiRows, setKpiRows] = useState([])
  const [expanded, setExpanded] = useState('inline')
  const [drawerTimeAgg, setDrawerTimeAgg] = useState('monthly')
  const [, setNewRow] = useState({ period: '', real: '' })

  //loads the "real" lines of KPI in desc
  const loadDataFromKPI = async agg => {
    setIsDrawerLoading(true) // Mova para o topo para garantir que o loading sempre inicie
    try {
      if (!kpi.initiativeKpiId) {
        // console.warn("No initiativeKpiId found in 'kpi' object!")
        setIsDrawerLoading(false) // Pare o loading se não houver ID
        return
      }

      const resp = await client.post('/api/initiative-kpi-values/', {
        action: 'list',
        initiative_kpi_id: kpi.initiativeKpiId,
        dimension: agg
      })

      if (resp.data && resp.data.success) {
        // A API já retorna as linhas com todos os dados que precisamos
        // A única coisa a fazer é garantir que todos os campos esperados existam
        const newRows = resp.data.rows.map(row => {
          // O backend agora envia 'period' diretamente, não precisa mais de slice
          return {
            id: row.id, // CORRIGIDO: Usando o ID real vindo da API
            period: row.period,
            baseline: row.baseline ?? null, // Target Baseline
            planned: row.planned ?? null,
            real: row.actual ?? null,
            approval_status: row.approval_status || 'approved', // Garante um valor padrão
            isNew: false
          }
        })

        // O backend já envia os dados na ordem correta (mais recente primeiro),
        // então a reversão não é mais necessária.
        setKpiRows(newRows)
      } else {
        // console.error('Error fetching combined planned+actual:', resp.data)
        setKpiRows([]) // Limpa a tabela em caso de erro
      }
    } catch (err) {
      // console.error('Error calling initiative-kpi-values (list):', err)
      setKpiRows([]) // Limpa a tabela em caso de erro na chamada
    } finally {
      setIsDrawerLoading(false) // Garante que o loading pare no final
    }
  }
  const drawerIcon =
    drawerTimeAgg === 'monthly' ? faCalendarPlus : faCalendarMinus
  const drawerTippyLabel =
    drawerTimeAgg === 'monthly'
      ? t('results_kpi.yearly')
      : t('results_kpi.monthly')
  //When changing Monthly/Yearly's toggle *inside *from the drawer
  //recharges data from the other array
  const handleToggleDrawerTimeAgg = () => {
    const newAgg = drawerTimeAgg === 'monthly' ? 'yearly' : 'monthly'

    setDrawerTimeAgg(newAgg)
    //recharges data
    loadDataFromKPI(newAgg)
  }

  //========== Add new line at the top ============
  const handleAddRowOnTop = () => {
    const newRow = { id: Date.now(), period: '', real: '', isNew: true }
    setKpiRows(prev => [newRow, ...prev]) // insere no topo
  }

  const handleRemoveRow = rowId => {
    setKpiRows(prev =>
      prev.map(row => {
        if (row.id === rowId) {
          // Zera o valor do actual (real)
          return {
            ...row,
            real: null
          }
        }
        return row
      })
    )
  }

  //Updates the value of "Period" or "Value" on a specific line
  const handleCellChange = (period, field, newValue) => {
    setKpiRows(prevRows =>
      prevRows.map(row =>
        row.period === period ? { ...row, [field]: newValue } : row
      )
    )
  }

  const handleFileUpload = e => {
    const file = e.target.files?.[0]
    if (!file) return
    //process the file (CSV, XLSX, etc.) with filereader or libraries
    //and then popular setkpirows ([...])
    // console.log('Arquivo recebido:', file)
  }

  //Allows you to download the "last file" that the user uploaded
  const handleDownloadLastUploaded = () => {
    if (!lastUploadedFile) return
    const url = URL.createObjectURL(lastUploadedFile)
    const link = document.createElement('a')
    link.href = url
    link.download = lastUploadedFile.name || 'historico_kpi.xlsx'
    link.click()
    URL.revokeObjectURL(url)
  }

  //function of "saving" changes (shipping to back-end, etc.)
  const handleSaveData = async () => {
    // Ativa loading imediatamente ao clicar
    setIsSaving(true)
    
    try {
      // Constrói os dados para envio (otimizado: usa slice para evitar mutação)
      const rowsToSend = kpiRows.slice().reverse().map(r => ({
        date: r.period,
        target: hasTargetBaseline && r.planned !== null ? Number(r.planned) : undefined,
        actual: r.real === '' ? 0 : Number(r.real)
      }))

      const resp = await client.post('/api/initiative-kpi-values/', {
        action: 'save',
        initiative_kpi_id: kpi.initiativeKpiId,
        dimension: drawerTimeAgg,
        rows: rowsToSend
      })

      if (resp.data && resp.data.success) {
        // Aguarda o reload dos KPIs para garantir que os gráficos estejam atualizados
        if (onReloadKpis) {
          try {
            await onReloadKpis()
          } catch (err) {
            console.error('Error reloading KPIs:', err)
            // Continua mesmo se o reload falhar
          }
        }
        
        // Fecha o drawer após os gráficos serem atualizados
        setOpenDrawer(false)
      } else {
        // console.error('Error saving KPI values:', resp.data)
        alert('Error saving KPI Values')
      }
    } catch (err) {
      // console.error('Error handleSaveData:', err)
      alert('Error calling API to save KPI Values')
    } finally {
      setIsSaving(false)
    }
  }

  const [lastUploadedFile] = useState(null)

  const thresholdsInfo = formatThresholds(kpi)
  const data = filteredData

  //Function to obtain the label corresponding to the value of the slider
  const getLabelFromMarks = (value, marks) => {
    const mark = marks.find(m => m.value === value)
    return mark ? mark.label : '--' //If you don't find it, displays "-" (change to "" if you want empty)
  }

  const MemoizedChart = React.memo(
    ({
      timeAgg,
      viewMode,
      clientColor,
      data,
      trackingMode,
      thresholdsConfig
    }) => {
      return (
        <MultiSeriesLineChartvBAR
          timeAgg={timeAgg}
          viewMode={viewMode}
          clientColor={clientColor}
          data={data}
          trackingMode={trackingMode}
          thresholdsConfig={thresholdsConfig}
          unit={kpi?.unit || ''}
          showUnitBefore={true}
        />
      )
    }
  )

  //custom component for Valuelabel
  function ValueLabelComponent(props) {
    const { children, open, value, marks } = props
    const label = getLabelFromMarks(value, marks)

    return label !== '--' ? ( //only displays Tooltip if there is a valid value
      <Tooltip open={open} enterTouchDelay={0} placement='top' title={label}>
        {children}
      </Tooltip>
    ) : (
      children //If there is no corresponding label, keep the slider without Tooltip
    )
  }

  //✅ Adding Proptype validation to avoid Eslint error
  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
    marks: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired
  }
  // console.log(kpi)

  return (
    <>
      {/* Header with the buttons*/}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          padding: 0,
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '5px',
          marginBottom: '-25px',
          marginRight: '3px'
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            marginLeft: '25px'
          }}
        >
          <Slider
            value={sliderRange} //State of Range
            onChange={(event, newValue) => setSliderRange(newValue)}
            ValueLabelComponent={props => (
              <ValueLabelComponent {...props} marks={marks} />
            )} //Displays values when dragging
            step={1} //Step from 1 in 1
            min={0}
            max={allLabels.length - 1}
            marks={marks}
            disableSwap //prevents changing the selectors order
            className={classes.slider}
          />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            marginLeft: '20px',
            marginTop: '-10px'
          }}
        >
          {allowKpiEdits &&
            (kpi.type === 'initiative' || kpi.type === 'program') && (
              <>
                <div style={{ marginBottom: '10px', gap: '5px' }}>
                  {allowKpiEdits && (
                    <Tooltip title={t('results_kpi.add_data')}>
                      <Button
                        color='client'
                        size='small'
                        variant='outlined'
                        onClick={() => handleOpenDrawer('add')}
                        className={classes.cardButtonNoMargin}
                      >
                        <Edit
                          style={{ fontSize: '20px' }}
                          className={classes.cardButtonIcon}
                        />
                      </Button>
                    </Tooltip>
                  )}
                </div>
              </>
            )}
          <div style={{ marginBottom: '10px' }}>
            <Tippy
              content={
                timeAgg === 'monthly'
                  ? t('results_kpi.yearly')
                  : t('results_kpi.monthly')
              }
              arrow={true}
              theme='light'
            >
              <Button
                color='client'
                size='small'
                variant='outlined'
                onClick={toggleTimeAgg}
                className={classes.cardButtonNoMargin}
                style={{ marginRight: '5px' }}
              >
                <FontAwesomeIcon
                  icon={
                    timeAgg === 'monthly' ? faCalendarPlus : faCalendarMinus
                  }
                  className={classes.cardButtonIcon}
                />
              </Button>
            </Tippy>

            <Tippy
              content={
                viewMode === 'chart'
                  ? t('results_kpi.table')
                  : t('results_kpi.chart')
              }
              arrow={true}
              theme='light'
            >
              <Button
                color='client'
                size='small'
                variant='outlined'
                onClick={toggleViewMode}
                className={classes.cardButtonNoMargin}
              >
                <FontAwesomeIcon
                  icon={viewMode === 'chart' ? faTable : faChartLine}
                  className={classes.cardButtonIcon}
                />
              </Button>
            </Tippy>
          </div>
        </div>
      </div>
      <Card style={{ marginBottom: '16px' }}>
        <CardHeader color='client' icon>
          <CardIcon color='client' icon>
            <FontAwesomeIcon icon={faChartSimple} />
          </CardIcon>

          <h4
            className={classes.cardIconTitle}
            style={{
              flexGrow: 1,
              maxWidth: '70%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {kpi.title}
            {allowKpiEdits && kpi.has_pending_changes && (
              <Tooltip title={t('approvals.pending_approval_tooltip')}>
                <HourglassEmpty
                  style={{
                    color: '#F4C430',
                    fontSize: 12,
                    // Adicione um pouco de ajuste vertical se necessário
                    transform: 'translateY(5px)'
                  }}
                />
              </Tooltip>
            )}
          </h4>

          <div
            style={{
              display: 'flex',
              padding: 0,
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '2px',
              marginTop: '-35px',
              marginLeft: '10px'
            }}
          >
            <Tippy
              content={
                <span
                  dangerouslySetInnerHTML={{
                    __html: thresholdsInfo
                  }}
                />
              }
              theme='light'
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                style={{
                  fontSize: '16px',
                  color: '#3C4858',
                  cursor: 'pointer'
                }}
              />
            </Tippy>
            <Tooltip title={t('results_kpi.fullscreen')}>
              <Fullscreen
                onClick={handleOpenFullScreen}
                style={{ fontSize: '20px', color: '#3C4858' }}
                className={classes.iconButtonCustom}
              />
            </Tooltip>
          </div>
        </CardHeader>
        <CardBody style={{ overflow: 'hidden', padding: '0' }}>
          <div>
            <div className={classes.chartContainer}>
              <div className={classes.chartContainer}>
                <MemoizedChart
                  timeAgg={timeAgg}
                  viewMode={viewMode}
                  clientColor={clientColor}
                  data={data}
                  performanceOrientation={kpi.performanceOrientation}
                  thresholdsConfig={kpi.thresholdsConfig}
                />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* Dialog to display the expanded chart */}
      <Dialog
        open={openFullScreenDialog}
        onClose={handleCloseFullScreen}
        maxWidth='lg'
        fullWidth
      >
        <Card style={{ padding: 5 }}>
          <CardHeader color='client' icon>
            <CardIcon color='client'>
              <FontAwesomeIcon icon={faChartSimple} />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{kpi.title}</h4>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'flex-start',
                marginLeft: '25px'
              }}
            >
              <Slider
                value={sliderRange} //State of Range
                onChange={(event, newValue) => setSliderRange(newValue)}
                ValueLabelComponent={props => (
                  <ValueLabelComponent {...props} marks={marks} />
                )} //Displays values when dragging
                step={1} //Step from 1 in 1
                min={0}
                max={allLabels.length - 1}
                marks={marks}
                disableSwap //prevents changing the selectors order
                className={classes.slider}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                right: '2px',
                top: '1px',
                position: 'absolute',
                zIndex: 1200
              }}
            >
              <Tooltip
                title={
                  <span dangerouslySetInnerHTML={{ __html: thresholdsInfo }} />
                }
                arrow
              >
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{
                    fontSize: '12px',
                    color: '#3C4858',
                    cursor: 'pointer',
                    marginTop: '1px'
                  }}
                />
              </Tooltip>
              <Tippy
                content={
                  timeAgg === 'monthly'
                    ? t('results_kpi.yearly')
                    : t('results_kpi.monthly')
                }
                arrow={true}
                theme='light'
              >
                <Button
                  color='client'
                  size='small'
                  variant='outlined'
                  onClick={toggleTimeAgg}
                  className={classes.cardButtonNoMargin}
                  style={{ marginRight: '5px' }}
                >
                  <FontAwesomeIcon
                    icon={
                      timeAgg === 'monthly' ? faCalendarPlus : faCalendarMinus
                    }
                    className={classes.cardButtonIcon}
                  />
                </Button>
              </Tippy>

              <Tippy
                content={
                  viewMode === 'chart'
                    ? t('results_kpi.table')
                    : t('results_kpi.chart')
                }
                arrow={true}
                theme='light'
              >
                <Button
                  color='client'
                  size='small'
                  variant='outlined'
                  onClick={toggleViewMode}
                  className={classes.cardButtonNoMargin}
                >
                  <FontAwesomeIcon
                    icon={viewMode === 'chart' ? faTable : faChartLine}
                    className={classes.cardButtonIcon}
                  />
                </Button>
              </Tippy>
              <CloseIcon
                className={classes.iconButtonCustom}
                style={{
                  cursor: 'pointer',
                  fontSize: '20px',
                  color: '#3C4858',
                  marginLeft: '15px',
                  marginTop: '1px'
                }}
                onClick={handleCloseFullScreen}
              />
            </div>
          </CardHeader>
          <CardBody style={{ overflow: 'hidden', padding: '0' }}>
            <div className={classes.chartContainer}>
              <div className={classes.chartContainer}>
                <MemoizedChart
                  timeAgg={timeAgg}
                  viewMode={viewMode}
                  clientColor={clientColor}
                  data={data}
                  trackingMode={kpi.trackingMode}
                  thresholdsConfig={kpi.thresholdsConfig}
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </Dialog>

      {/* DRAWER */}
      {allowKpiEdits && (
        <Drawer
          anchor='right'
          open={openDrawer}
          onClose={handleCloseDrawer}
          classes={{ paper: classes.drawerPaper }}
          BackdropProps={{
            style: { backgroundColor: '#000', opacity: '0.1' }
          }}
          PaperProps={{
            style: {
              borderRadius: '10px',
              margin: '1vh 1vh 1vh 0',
              height: '98vh'
            }
          }}
        >
          <div style={classes.drawerContainer}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {/* Title */}
              <Typography variant='h6' style={{ marginBottom: 8 }}>
                {kpi.title}
              </Typography>
              {/* Final buttons (save and close)*/}
              <div style={{ marginRight: '7px' }}>
                <Tooltip title={t('results_kpi.save')}>
                  {/* O span é necessário para o Tooltip funcionar quando o botão está desabilitado */}
                  <span>
                    <Button
                      justIcon // Prop customizada do seu template para um botão circular
                      color='client'
                      // Reutilize a classe que você já usa para botões de card
                      className={classes.cardButton}
                      onClick={handleSaveData}
                      // Desabilita o botão durante o salvamento ou aprovação
                      disabled={isSaving || isActionLoading}
                    >
                      {/* Lógica ternária para alternar entre o spinner e o ícone */}
                      {(isSaving || isActionLoading) ? (
                        <ThreeDots
                          color='white' // Assumindo que o fundo do botão é a cor do cliente
                          height={20} // Ajuste o tamanho para caber no botão
                          width={20}
                          ariaLabel='loading'
                        />
                      ) : (
                        <Save className={classes.cardButtonIcon} />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </div>

            {/* Section 1: INLINE EDITION (ACCORDION)*/}
            <Accordion
              expanded={expanded === 'inline'}
              onChange={(_, isExpanded) =>
                setExpanded(isExpanded ? 'inline' : '')
              }
              className={classes.accordionRootCustom}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant='subtitle1'>
                  <FontAwesomeIcon
                    style={{
                      fontSize: '18px',
                      marginRight: '5px',
                      color: '#3C4858'
                    }}
                    icon={faFilePen}
                    className={classes.iconButtonCustom}
                  />
                  {t('results_kpi.edit_inline')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails style={{ flexDirection: 'column' }}>
                {isDrawerLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '80px'
                    }}
                  >
                    <ThreeDots
                      color={clientColor}
                      height={40}
                      width={40}
                      ariaLabel='loading'
                    />
                  </div>
                ) : (
                  <>
                    {/* Buttons - innactivated for now 
                  <div
                    style={{
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    
                    <Tooltip title={t("results_kpi.add_line")}>
                      <AddCircle
                        color="client"
                        onClick={handleAddRowOnTop}
                        className={classes.iconButtonCustom}
                        style={{ marginRight: "5px", color: "#3C4858" }}
                      />
                    </Tooltip>
                    <Tippy
                      content={drawerTippyLabel}
                      arrow={true}
                      theme="light"
                    >
                      <FontAwesomeIcon
                        icon={drawerIcon}
                        onClick={handleToggleDrawerTimeAgg}
                        className={classes.iconButtonCustom}
                        style={{
                          marginRight: "5px",
                          fontSize: "20px",
                          color: "#3C4858",
                          cursor: "pointer",
                        }}
                      />
                    </Tippy>
                  </div>
                  */}
                    {/* explicação de cumulativo / não-cumulativo */}
                    <Alert severity='info' sx={{ mb: 5 }}>
                      {kpi.is_cumulative
                        ? t('results_kpi.help_cumulative')
                        : t('results_kpi.help_non_cumulative')}
                    </Alert>
                    <Box marginBottom={'25px'} />
                    {isTableLoading && (
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(255, 255, 255, 0.7)',
                          zIndex: 10,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '4px'
                        }}
                      >
                        <ThreeDots color={clientColor} height={50} width={50} />
                      </div>
                    )}
                    {/* Tabela de Planned/Actual */}
                    <Table
                      className={classes.table}
                      style={{ minWidth: '500px' }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className={classes.tableCell}
                            style={{ textAlign: 'left', width: hasTargetBaseline ? '25%' : '30%' }}
                          >
                            {t('results_kpi.time_period')}
                          </TableCell>
                          {hasTargetBaseline && (
                          <TableCell
                            className={classes.tableCell}
                              style={{ textAlign: 'center', width: '20%' }}
                            >
                              {t('results_kpi.baseline')}
                            </TableCell>
                          )}
                          <TableCell
                            className={classes.tableCell}
                            style={{ textAlign: 'center', width: hasTargetBaseline ? '20%' : '25%' }}
                          >
                            {t('results_kpi.planned')}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ textAlign: 'center', width: hasTargetBaseline ? '20%' : '25%' }}
                          >
                            {t('results_kpi.actual')}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ textAlign: 'center', width: hasTargetBaseline ? '15%' : '20%' }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <span>{t('results_kpi.actions')}</span>
                              {/* =========================================== */}
                              {/* 3. Botão de Approve All no Cabeçalho */}
                              {/* =========================================== */}
                              {canApprove &&
                                kpiRows.some(
                                  r => r.approval_status === 'pending'
                                ) && (
                                  <Tooltip title={t('approvals.approve_all')}>
                                    <IconButton
                                      size='small'
                                      onClick={() =>
                                        onApproveAll(kpi.initiativeKpiId)
                                      }
                                      disabled={isActionLoading} // Usa a prop de loading
                                      style={{ marginLeft: '8px' }}
                                    >
                                      <ChecklistRtlIcon fontSize='small' />
                                    </IconButton>
                                  </Tooltip>
                                )}
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {kpiRows.map(row => (
                          <TableRow key={row.period}>
                            {/* Período */}
                            <TableCell className={classes.tableCellNoBorder}>
                              <TextField
                                size='small'
                                value={row.period}
                                onChange={e =>
                                  handleCellChange(
                                    row.id,
                                    'period',
                                    e.target.value
                                  )
                                }
                                fullWidth
                                type={
                                  drawerTimeAgg === 'monthly'
                                    ? 'month'
                                    : 'number'
                                }
                                disabled={!row.isNew}
                                classes={{ root: classes.textFieldRoot }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                  style: { fontSize: '13px' }
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true
                                }}
                                FormHelperTextProps={{
                                  classes: { root: classes.helperText }
                                }}
                              />
                            </TableCell>

                            {/* BASELINE => somente leitura (se habilitado) */}
                            {hasTargetBaseline && (
                              <TableCell
                                align='center'
                                className={classes.tableCellNoBorder}
                                style={{ verticalAlign: 'middle' }}
                              >
                                <TextField
                                  size='small'
                                  value={
                                    row.baseline !== null
                                      ? formatNumber(row.baseline, kpi.unit, true)
                                      : ''
                                  }
                                  disabled // read-only
                                  style={{ width: '90%' }}
                                  inputProps={{ style: { textAlign: 'center' } }}
                                />
                              </TableCell>
                            )}

                            {/* PLANNED => editável quando hasTargetBaseline, senão read-only */}
                            <TableCell
                              align='center'
                              className={classes.tableCellNoBorder}
                              style={{ verticalAlign: 'middle' }}
                            >
                              <TextField
                                size='small'
                                value={
                                  hasTargetBaseline && row.planned !== null
                                    ? row.planned
                                    : row.planned !== null
                                    ? formatNumber(row.planned, kpi.unit, true)
                                    : ''
                                }
                                onChange={hasTargetBaseline ? (e =>
                                  handleCellChange(
                                    row.period,
                                    'planned',
                                    e.target.value
                                  )) : undefined}
                                disabled={!hasTargetBaseline}
                                fullWidth
                                type={hasTargetBaseline ? 'number' : 'text'}
                                classes={{ root: classes.textFieldRoot }}
                                style={{
                                  width: '90%',
                                  backgroundColor: !hasTargetBaseline
                                    ? '#f5f5f5'
                                    : undefined
                                }}
                                inputProps={{ style: { textAlign: 'center' } }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                  style: { fontSize: '13px' }
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true
                                }}
                              />
                            </TableCell>

                            {/* ACTUAL => editável */}
                            <TableCell
                              align='center'
                              className={classes.tableCellNoBorder}
                              style={{ verticalAlign: 'middle' }}
                            >
                              <TextField
                                size='small'
                                value={row.real === null ? '' : row.real}
                                onChange={e =>
                                  handleCellChange(
                                    row.period,
                                    'real',
                                    e.target.value
                                  )
                                }
                                fullWidth
                                type='number'
                                classes={{ root: classes.textFieldRoot }}
                                disabled={isFuturePeriod(row.period)}
                                style={{
                                  backgroundColor: isFuturePeriod(row.period)
                                    ? '#f5f5f5' // tom de cinza claro para indicar disabled
                                    : undefined
                                }}
                                inputProps={{ style: { textAlign: 'center' } }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                  style: { fontSize: '13px' }
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true
                                }}
                              />
                            </TableCell>

                            {/* Coluna final para remover */}
                            <TableCell
                              align='center'
                              className={classes.tableCellNoBorder}
                              style={{ verticalAlign: 'middle' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}
                              >
                                {/* Regra 1: Se a linha está pendente, SEMPRE mostra a ampulheta */}
                                {row.approval_status === 'pending' && (
                                  <Tooltip
                                    title={t(
                                      'approvals.pending_approval_tooltip'
                                    )}
                                  >
                                    <HourglassEmpty
                                      style={{ color: '#F4C430', fontSize: 18 }}
                                    />
                                  </Tooltip>
                                )}

                                {/* Regra 2: Se a linha está pendente E o usuário PODE aprovar, mostra os botões de ação */}
                                {row.approval_status === 'pending' &&
                                  canApprove && (
                                    <>
                                      <Tooltip title={t('approvals.reject')}>
                                        <span>
                                          <IconButton
                                            size='small'
                                            onClick={() =>
                                              onApprovalAction(row.id, 'reject')
                                            }
                                            disabled={isActionLoading} // Usa a prop de loading
                                          >
                                            <Cancel
                                              style={{
                                                color: isActionLoading
                                                  ? '#ccc'
                                                  : '#d32f2f'
                                              }}
                                              fontSize='small'
                                            />
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                      <Tooltip title={t('approvals.approve')}>
                                        <span>
                                          <IconButton
                                            size='small'
                                            onClick={() =>
                                              onApprovalAction(
                                                row.id,
                                                'approve'
                                              )
                                            }
                                            disabled={isActionLoading} // Usa a prop de loading
                                          >
                                            <CheckCircle
                                              style={{
                                                color: isActionLoading
                                                  ? '#ccc'
                                                  : 'green'
                                              }}
                                              fontSize='small'
                                            />
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    </>
                                  )}

                                {/* Regra 3: Se a linha NÃO está pendente, mostra o botão de deletar, */}
                                {/* que só é funcional para quem pode aprovar (ou editar, dependendo da sua regra final) */}
                                {row.approval_status !== 'pending' && (
                                  <Tooltip title={t('execution.delete')}>
                                    <span>
                                      <IconButton
                                        size='small'
                                        onClick={() => {
                                          // A ação só é executada se o usuário tiver permissão
                                          if (
                                            canApprove &&
                                            !isFuturePeriod(row.period)
                                          ) {
                                            handleRemoveRow(row.id)
                                          }
                                        }}
                                        // O botão fica visualmente desabilitado se não puder aprovar ou for um período futuro
                                        disabled={
                                          !canApprove ||
                                          isFuturePeriod(row.period)
                                        }
                                        className={classes.iconButtonCustom}
                                      >
                                        <Delete
                                          fontSize='small'
                                          className={classes.iconButtonCustom}
                                        />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </>
                )}
              </AccordionDetails>
            </Accordion>

            {/* Section 2: Upload /Download (Accordion)
          <Accordion
           expanded={expanded === "upload"}
            onChange={(_, isExpanded) =>
              setExpanded(isExpanded ? "upload" : "")
            }
            className={classes.accordionRootCustom}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                <FontAwesomeIcon
                  style={{
                    fontSize: "18px",
                    marginRight: "5px",
                    color: "#3C4858",
                  }}
                  icon={faFileArrowUp}
                  className={classes.iconButtonCustom}
                />
                {t("results_kpi.edit_upload")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ flexDirection: "column" }}>
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                {t("results_kpi.add_data_upload")}
              </Typography>

              <div style={{ marginBottom: 16 }}>
                <Box display="flex" alignItems="center" gap={8}>
                  <input
                    accept=".xlsx,.xls,.csv"
                    className={classes.fileInput}
                    id="kpi-file-upload"
                    type="file"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="kpi-file-upload">
                    <Button
                      variant="contained"
                      color="client"
                      component="span"
                      style={{
                        marginBottom: "5px",
                        boxShadow: "none",
                        width: "250px",
                      }}
                    >
                      {t("results_kpi.upload_file")}
                    </Button>
                  </label>
                </Box>

                <Button
                  variant="outlined"
                  color="client"
                  onClick={handleDownloadLastUploaded}
                  style={{
                    width: "250px",
                  }}
                >
                  {t("results_kpi.download_last_file")}
                </Button>
              </div>
            </AccordionDetails>
          </Accordion>
          */}
          </div>
        </Drawer>
      )}
    </>
  )
}

KPIChartCard.propTypes = {
  kpi: PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    trackingMode: PropTypes.string.isRequired,
    thresholdsConfig: PropTypes.object.isRequired,
    data: PropTypes.shape({
      monthly: PropTypes.object,
      yearly: PropTypes.object
    }).isRequired
  }).isRequired,
  t: PropTypes.func.isRequired,
  clientColor: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  onReloadKpis: PropTypes.func,
  allowKpiEdits: PropTypes.bool,
  canApprove: PropTypes.bool,
  onApprovalAction: PropTypes.func,
  onApproveAll: PropTypes.func,
  isActionLoading: PropTypes.bool,
  hasTargetBaseline: PropTypes.bool
}

KPIChartCard.defaultProps = {
  allowKpiEdits: true
}

const isFuturePeriod = period => {
  // period no formato "YYYY-MM"
  const [y, m] = period.split('-').map(Number)
  const d = new Date(y, m - 1)
  const now = new Date()
  // compara só ano/mês
  return (
    d.getFullYear() > now.getFullYear() ||
    (d.getFullYear() === now.getFullYear() && d.getMonth() > now.getMonth())
  )
}

export default function InitiativeResultsPage(props) {
  const {
    selectedInitiative,
    t,
    classes,
    clientColor,
    initiativeKpisData,
    onReloadKpis,
    onReloadInitiatives,
    allowKpiEdits = true, // new prop (default: true)
    allowKpiExports = true // new prop (default: true)
  } = props

  // APPROVALS
  // 1. Obtenha o userDetails e a permissão contextual
  const { userDetails } = React.useContext(AuthContext)
  const canApproveResults =
    userDetails?.permissions?.can_approve_kpi_values &&
    (userDetails.email === props.selectedInitiative.leader_email ||
      userDetails.email === props.selectedInitiative.pmo_email)
  
  // Check if target_baseline is enabled
  const hasTargetBaseline = userDetails?.has_target_baseline || false

  const [isActionLoading, setIsActionLoading] = useState(false)

  const handleApprovalAction = async (initiativeValueId, action) => {
    setIsActionLoading(true); // Usa o state do pai
    try {
      const response = await performResultsApprovalAction({
        initiative_value_id: initiativeValueId,
        action,
      });

      if (response && response.success) {
        toast.success(t("approvals.action_successful"));
        if (onReloadKpis) { // Usa a prop onReloadKpis
          await onReloadKpis();
        }
      } else {
        toast.error(response.error || t("errors.action_failed"));
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || t("errors.action_failed");
      toast.error(errorMsg);
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleApproveAll = async (initiativeKpiId) => { // A função precisa saber o KPI
    setIsActionLoading(true);
    try {
      const response = await approveAllResults(initiativeKpiId);
      if (response && response.success) {
        toast.success(response.message || t("approvals.all_approved"));
        if (onReloadKpis) {
          await onReloadKpis();
        }
      } else {
        toast.error(response.error || t("errors.action_failed"));
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || t("errors.action_failed");
      toast.error(errorMsg);
    } finally {
      setIsActionLoading(false);
    }
  };


  //Get the selected initiative kpis
  const initiativeData = initiativeKpisData || { kpis: [] }
  // console.log('InitiativeResultsPage - initiativeData:', initiativeData)

  const programKPIs = initiativeData.kpis.filter(kpi => kpi.type === 'program')
  // console.log('InitiativeResultsPage - programKPIs:', programKPIs)

  const initiativeKPIs = initiativeData.kpis.filter(
    kpi => kpi.type === 'initiative'
  )
  // console.log('InitiativeResultsPage - initiativeKPIs:', initiativeKPIs)
  //determines which tab should be started
  const initialTabIndex =
    programKPIs.length > 0 ? 0 : initiativeKPIs.length > 0 ? 1 : 0

  const [resultsTypeTabIndex, setResultsTypeTabIndex] =
    useState(initialTabIndex)

  //Function to determine the Grid item props based on the number of kpis in the same subtype
  function getGridProps(count, index) {
    if (count === 1) return { xs: 12, sm: 12, md: 12 }
    if (count === 2) return { xs: 12, sm: 6, md: 6 }
    if (count === 3) {
      //to 3, the first two occupy half and the third occupies 12
      return index < 2 ? { xs: 12, sm: 6, md: 6 } : { xs: 12, sm: 12, md: 12 }
    }
    //to 4 or more, we can use two columns (adjustment as needed)
    return { xs: 12, sm: 6, md: 6 }
  }

  const kpiTabsConfig = [
    {
      type: 'program',
      tabLabel: t('results_kpi.program_tab'),
      kpiCards: programKPIs
    },
    {
      type: 'initiative',
      tabLabel: t('results_kpi.initiative_tab'),
      kpiCards: initiativeKPIs
    }
  ]

  const handleResultsPdfExport = () => {
    const activeTabConfig = kpiTabsConfig[resultsTypeTabIndex]

    if (
      activeTabConfig &&
      activeTabConfig.kpiCards &&
      activeTabConfig.kpiCards.length > 0
    ) {
      const sectionTitle =
        selectedInitiative && selectedInitiative.name
          ? `${activeTabConfig.tabLabel}: ${selectedInitiative.name}`
          : activeTabConfig.tabLabel

      // Adicione uma verificação para clientColor antes de chamar a função
      if (!clientColor || !/^#[0-9A-F]{6}$/i.test(clientColor)) {
        /*
        console.error(
          'Cor do cliente inválida para PDF:',
          clientColor,
          'Usando cor padrão.'
        )
        */
        generateKpiReportPdf({
          kpiCardsData: activeTabConfig.kpiCards,
          clientColor: '#007bff', // Cor padrão
          t: t,
          userDetails: userDetails,
          reportTitleKey: 'results_kpi.report_title_pdf',
          sectionTitle: sectionTitle,
          outputFilename: `KPI_Results_${
            selectedInitiative?.name || 'Report'
          }.pdf`
        })
        return // Interrompe
      }

      generateKpiReportPdf({
        kpiCardsData: activeTabConfig.kpiCards,
        clientColor: clientColor, // Agora sabemos que é válida ou foi substituída
        t: t,
        userDetails: userDetails, // Garantir que userDetails está aqui
        reportTitleKey: 'results_kpi.report_title_pdf',
        sectionTitle: sectionTitle,
        outputFilename: `KPI_Results_${
          selectedInitiative?.name || 'Report'
        }.pdf`
      })
    } else {
      // console.warn('Nenhum KPI para exportar na aba de resultados atual.')
    }
  }

  const handleGenerateExcel = () => {
    const activeTab = kpiTabsConfig[resultsTypeTabIndex]
    if (!activeTab) {
      // console.error('Nenhum TAB ativo encontrado para KPIs.')
      return
    }
    const workbook = XLSX.utils.book_new()
    activeTab.kpiCards.forEach((kpiCard, idx) => {
      if (kpiCard.data && kpiCard.data.monthly) {
        const { labels, series, seriesNames } = kpiCard.data.monthly
        const rows = []
        rows.push([kpiCard.title])
        rows.push([t('kpispage.labels.month'), ...seriesNames])
        labels.forEach((label, index) => {
          const row = [label]
          seriesNames.forEach((name, sIndex) => {
            row.push(series[sIndex][index] ?? '--')
          })
          rows.push(row)
        })
        const worksheet = XLSX.utils.aoa_to_sheet(rows)
        XLSX.utils.book_append_sheet(workbook, worksheet, `KPI ${idx + 1}`)
      }
    })
    XLSX.writeFile(workbook, t('results_kpi.report_xlsx'))
  }

  return (
    <div className={classes.root}>
      <Tabs
        value={resultsTypeTabIndex}
        onChange={(e, newValue) => setResultsTypeTabIndex(newValue)}
        variant='fullWidth'
        classes={{
          root: classes.tabsRoot,
          indicator: classes.indicator
        }}
      >
        <Tab
          label={t('results_kpi.program_tab')}
          disabled={programKPIs.length === 0}
          classes={{ root: classes.tabRoot }}
        />
        <Tab
          label={t('results_kpi.initiative_tab')}
          disabled={initiativeKPIs.length === 0}
          classes={{ root: classes.tabRoot }}
        />
      </Tabs>
      <Box
        position='relative'
        style={{
          backgroundColor: '#f5f5f5',
          border: '5px solid #fff',
          borderRadius: 8,
          marginRight: '-4px',
          marginLeft: '-4px'
        }}
      >
        {resultsTypeTabIndex === 0 &&
          ['topo', 'financial', 'budget'].map(subtype => {
            const kpisForSubtype = programKPIs.filter(
              kpi => kpi.subtype === subtype
            )
            return kpisForSubtype && kpisForSubtype.length > 0 ? (
              <div key={subtype}>
                <Grid sm={12} xs={12}>
                  <div
                    style={{
                      position: 'absolute',
                      right: '13px',
                      top: '13px',
                      zIndex: 1000,
                      display: 'flex',
                      gap: '6px'
                    }}
                  >
                    {allowKpiExports && (
                      <>
                        <Tooltip title={t('results_kpi.download_pdf')}>
                          <FontAwesomeIcon
                            icon={faFilePdf}
                            onClick={handleResultsPdfExport}
                            className={classes.iconButtonCustom}
                            style={{ fontSize: '20px' }}
                          />
                        </Tooltip>
                        <Tooltip title={t('results_kpi.download_xlsx')}>
                          <FontAwesomeIcon
                            onClick={handleGenerateExcel}
                            icon={faFileExcel}
                            className={classes.iconButtonCustom}
                            style={{ fontSize: '20px' }}
                          />
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Grid>
                <div style={{ margin: '3px 10px' }}>
                  <Typography
                    variant='h6'
                    style={{ marginTop: '16px', marginBottom: '8px' }}
                  >
                    {t(`results_kpi.${subtype}`)}
                  </Typography>
                  <Grid container spacing={2}>
                    {kpisForSubtype.map((kpi, index) => (
                      <Grid
                        item
                        {...getGridProps(kpisForSubtype.length, index)}
                        key={kpi.title}
                        style={{ marginTop: '2px' }}
                      >
                        <KPIChartCard
                          kpi={kpi}
                          t={t}
                          clientColor={clientColor}
                          classes={classes}
                          onReloadKpis={onReloadKpis}
                          onReloadInitiatives={onReloadInitiatives}
                          allowKpiEdits={allowKpiEdits}
                          canApprove={canApproveResults}
                          onApprovalAction={handleApprovalAction}
                          onApproveAll={handleApproveAll}
                          isActionLoading={isActionLoading}
                          hasTargetBaseline={hasTargetBaseline}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            ) : null
          })}
        {resultsTypeTabIndex === 1 &&
          ['financial', 'specific'].map(subtype => {
            const kpisForSubtype = initiativeKPIs.filter(
              kpi => kpi.subtype === subtype
            )
            return kpisForSubtype && kpisForSubtype.length > 0 ? (
              <div>
                <div key={subtype}>
                  <div
                    style={{
                      position: 'absolute',
                      right: '13px',
                      top: '13px',
                      zIndex: 1000,
                      display: 'flex',
                      gap: '6px'
                    }}
                  >
                    <Tooltip title={t('results_kpi.download_pdf')}>
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        onClick={generateKpiReportPdf}
                        className={classes.iconButtonCustom}
                        style={{ fontSize: '20px', color: '#3C4858' }}
                      />
                    </Tooltip>
                    <Tooltip title={t('results_kpi.download_xlsx')}>
                      <FontAwesomeIcon
                        onClick={handleGenerateExcel}
                        icon={faFileExcel}
                        className={classes.iconButtonCustom}
                        style={{ fontSize: '20px', color: '#3C4858' }}
                      />
                    </Tooltip>
                  </div>
                  <div style={{ margin: '3px 10px' }}>
                    <Typography
                      variant='h6'
                      style={{ marginTop: '16px', marginBottom: '8px' }}
                    >
                      {t(`results_kpi.${subtype}`)}
                    </Typography>
                    <Grid container spacing={2}>
                      {kpisForSubtype.map((kpi, index) => (
                        <Grid
                          item
                          key={kpi.title}
                          {...getGridProps(kpisForSubtype.length, index)}
                          style={{ marginTop: '2px' }}
                        >
                          <KPIChartCard
                            kpi={kpi}
                            t={t}
                            clientColor={clientColor}
                            classes={classes}
                            onReloadKpis={onReloadKpis}
                            allowKpiEdits={allowKpiEdits}
                            canApprove={canApproveResults}
                            onApprovalAction={handleApprovalAction}
                            onApproveAll={handleApproveAll}
                            isActionLoading={isActionLoading}
                            hasTargetBaseline={hasTargetBaseline}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </div>
              </div>
            ) : null
          })}
      </Box>
    </div>
  )
}

InitiativeResultsPage.propTypes = {
  selectedInitiative: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  clientColor: PropTypes.string,
  classes: PropTypes.object.isRequired,
  initiativeKpisData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      initiative: PropTypes.string,
      kpis: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          subtype: PropTypes.string,
          trackingMode: PropTypes.string.isRequired,
          thresholdsConfig: PropTypes.object.isRequired,
          data: PropTypes.shape({
            monthly: PropTypes.object,
            yearly: PropTypes.object
          }).isRequired
        })
      )
    })
  ).isRequired,
  onReloadKpis: PropTypes.func,
  allowKpiEdits: PropTypes.bool,
  allowKpiExports: PropTypes.bool
}

InitiativeResultsPage.defaultProps = {
  allowKpiEdits: true,
  allowKpiExports: true
}
